$(() => {
  if ($(".js-nav").length <= 0) return;

  const navHeader = document.querySelector(".js-nav");
  const observer = new IntersectionObserver(
    (entries) => {
      navHeader.classList.toggle(
        "is-active",
        entries.some((e) => e.isIntersecting)
      );
    },
    { rootMargin: "0% 0% -100% 0%" }
  );
  observer.observe(document.querySelector(".p-spots-show .l-container"));
});
